// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__0PB64","input":"default_input__y1spn","error":"default_error__gICcy","disabled":"default_disabled__Gm+Qf","spin":"default_spin__5rsBC"};